import { render, staticRenderFns } from "./PromptItem.vue?vue&type=template&id=56cff342&scoped=true"
import script from "./PromptItem.vue?vue&type=script&lang=js"
export * from "./PromptItem.vue?vue&type=script&lang=js"
import style0 from "./PromptItem.vue?vue&type=style&index=0&id=56cff342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cff342",
  null
  
)

export default component.exports